module.exports = __webpack_public_path__ + "img/photo2.31725b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo2.jpg
// module id = UCPx
// module chunks = 1